import { render, staticRenderFns } from "./FileDetail.vue?vue&type=template&id=7a82fea8&scoped=true"
import script from "./FileDetail.vue?vue&type=script&lang=js"
export * from "./FileDetail.vue?vue&type=script&lang=js"
import style0 from "./FileDetail.vue?vue&type=style&index=0&id=7a82fea8&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a82fea8",
  null
  
)

export default component.exports